const api = token => {
  const baseURL = 'https://app.gestorfood.com/gfdeliveryv2';

  const index = async function index() {
    // const sdata = localStorage.getItem('data');
    // if (sdata) return JSON.parse(sdata);

    const url = `${baseURL}/?t=${token}`;

    const res = await fetch(url, { method: 'GET' });

    const data = await res.json();

    // localStorage.setItem('data', JSON.stringify(data));

    return data;
  };

  const addressset = async function addressset(address) {
    const url = `${baseURL}/addressset/?t=${token}`;

    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(address),
    });

    const data = await res.json();

    return data || null;
  };

  const orderget = async function orderget() {
    const url = `${baseURL}/orderget/?t=${token}`;

    const res = await fetch(url, { method: 'GET' });

    const data = await res.json();

    return data || null;
  };

  const orderset = async function orderset(order) {
    const url = `${baseURL}/orderset/?t=${token}`;

    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(order),
    });

    const data = await res.json();

    return data || null;
  };

  return {
    index,
    addressset,
    orderget,
    orderset,
  };
};

export default api;
